import { createContext as i } from "react";
function n() {
  return {
    activeRef: null,
    listeners: /* @__PURE__ */ new Set(),
    subscribe(e) {
      return this.listeners.add(e), () => {
        this.listeners.delete(e);
      };
    },
    show(e) {
      this.activeRef = e, this.listeners.forEach((t) => t(e));
    },
    hide(e) {
      this.activeRef === e && (this.activeRef = null, this.listeners.forEach((t) => t(null)));
    }
  };
}
const l = /* @__PURE__ */ i(void 0);
export {
  l as T,
  n as c
};
//# sourceMappingURL=__utils-b06e21f1.js.map
